<template lang="html">
  <div class="map-nav-button">
    <div class="map-nav-button--content"
         :class="{'map-nav-button--active': active}"
         @mousedown="isMouseDown = true"
         @mouseup="isMouseDown = false"
         @mouseout="isMouseDown = false"
         @click="$emit('click')">
      <img :src="image" class="map-nav-button__image">
      <div>
        {{ label }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapNavButton',
  props: {
    idle: {
      type: String,
      default: ''
    },
    pressed: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    console.log(this.active);
  },
  data() {
    return {
      isMouseDown: false
    };
  },
  computed: {
    image() {
      if (this.isMouseDown || this.active) return this.pressed;
      return this.idle;
    }
  }
};
</script>

<style lang="scss" scoped>
  .map-nav-button {
    width: 150px;
    height: 40px;
    background-color: #101010;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .15s;
    padding: 3px 0;

    &--content{
      width: calc(100% - 8px);
      height: 36px;
      border-radius: 4px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      color: #ADADAD;
    }
    &--active {
      cursor: default;
      color: #08CE82;
      background: #424242;
    }

    &__image {
      width: 28px;
      height: 28px;
      object-fit: contain;
      margin-right: 10px;
    }
  }
</style>
